// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1UiCR","disabled":"FileBtn_disabled__3K8b6","warn":"FileBtn_warn__1ZEPw","fade":"FileBtn_fade__279ZA"};